/**
 * 2026-10-08 — old /jobopenings/:id links (in-app navigation) → /careers/:id.
 * The server also answers these with a 301; this covers client-side routing.
 * Only an id-shaped value is carried over (no open redirect).
 */
import { Navigate, useParams } from 'react-router-dom';

export function OldJobOpeningRedirect() {
  const { id = '' } = useParams<{ id: string }>();
  const safe = /^[A-Za-z0-9_-]{1,100}$/.test(id) ? `/careers/${id}` : '/careers';
  return <Navigate to={safe} replace />;
}

export default OldJobOpeningRedirect;
